import { ws_init, ws_send, ws_close } from '../tools/soket'
import {isNotEmpty} from "../tools/utils";

function fetchUserBase() {
    return localStorage.getItem('userBase') ? JSON.parse(localStorage.getItem('userBase')) : {}
}
const channelOptions = {
    wsurl: process.env.VUE_APP_SOCKETSERVERHOST + '/ws/edi/' + fetchUserBase().company_mark + '/',
    ws: null,
    hartbeat: { command: "front_check", message: "check contect", to: "server", for: fetchUserNameForWS() },
    new_message: {},
    messages: [],
    on: true,
}
const state = () => ({
    channel: Object.assign({}, channelOptions)
})

const getters = {
    getWSurl: state => state.channel.wsurl,
    getChannel: state => state.channel.ws,
    getHartbeat: state => state.channel.hartbeat,
    getNewMessage: state => state.channel.new_message,
    getMessages: state => state.channel.messages,
    isChannelOn: state => state.channel.on,
    getStateCode: state => state.channel.code,
}

const mutations = {
    ['set_message'](state, data) {
        state.channel.new_message = data
        state.channel.messages.push(data)
    },

    ['update_channel_options'](state) {
        state.channel.wsurl = process.env.VUE_APP_SOCKETSERVERHOST + '/ws/edi/' + fetchUserBase().company_mark + '/'
        state.channel.hartbeat = { command: "front_check", message: "check contect", to: "server", for: fetchUserNameForWS() }
    },
}

const command_mapping = {

    'update_client__erp_material':'materialComp/return_update_client__erp_material',
    'get_client__material_export_excel':'materialData/return_export',
    'get_client__material_list':'materialData/return_list',
    'get_client__material_price_list':'listPrice/return_list',
    'get_client__material_price_export_excel':'listPrice/return_export',
    'get_client__material_source_list':'materialComp/return_list',
    'get_client__material_source_export_excel':'materialComp/return_export',

    'get_client__quotation_export_excel':'quotaion/return_export',

    'get_client__outbound_export_excel':'downstreamSales/return_export',
    'get_client__invoice':'proformaInvoice/return_list',
    'get_client__invoice_export_excel':'proformaInvoice/return_export',
    'get_client__confirm':'orderConfirmation/return_list',
    'get_client__confirm_export_excel':'orderConfirmation/return_export',
    'get_client__erp_purchase':'purchaseOrder/return_list',
    "delete_client__erp_purchase_send_tag":'purchaseOrder/clear_return',
    'post_client__erp_purchase_data':'purchaseOrder/return_list-push-data',
    'get_client__erp_purchase_export_excel':'purchaseOrder/return_export',
    'get_client__dn':'purchaseReceipt/return_list',

    'get_client__dn_stock':'purchaseReceipt/dn_stock_return',
    'get_client__hu_export_excel':'deliveryDetails/return_export',
    'post_client__erp_purchase_init':'sendPurchaseOrder/return_data',
    'get_client__inventory_export_excel':'inventoryInformation/return_export',
    'post_client__erp_reg_data':'sendPurchaseOrder/return_reg_data',
    'post_client__erp_purchase_send':'sendPurchaseOrder/return_send_data',
    'get_client__shipping':'shippingNotice/return_list',
    'get_client__shipping_export_excel':'shippingNotice/return_export',
    'get_client__quotation':'quotaion/return_list',
    'get_client__quotation_make_purchase':'quotaion/make_purchase_return',
    'get_client__quotation_make_purchase_tag':'quotaion/make_purchase_tag_return',
    'get_client__hu':'deliveryDetails/return_list',
    'get_client__outbound_history':'downstreamSales/return_list',
    'post_client__outbound_push_data':'downstreamSales/return_list-push-data',
    'post_client__outbound_push':'downstreamSales/pushDataReturn',
    'outbound_push_data_log':'downstreamSales/push_pushing_msg',
    'outbound_push_data_completed':'downstreamSales/set_pushing_completed',

    'get_client__inventory_history':'inventoryInformation/return_list',
    'post_client__inventory_push_data':'inventoryInformation/return_list-push-data',
    'post_client__inventory_push':'inventoryInformation/pushDataReturn',
    'inventory_push_data_log':'inventoryInformation/push_pushing_msg',
    'inventory_push_data_completed':'inventoryInformation/set_pushing_completed',
    'login_disable':'user/received_login_disable',
    'inventory__list':'inventory/return_inventory__list',
    'inventory__export':'inventory/return_inventory__export',
    'outbound__list':'sales/return_sales__list',
    'outbound__export':'sales/return_sales__export',
    'get_client__settings':'systemsettings/return_client_get__config',
    'save_client__settings':'systemsettings/return_client_write__config',
    'client_get__json':'erpfields/return_client_get__json',
    'client_write__json':'erpfields/return_client_write__json',


    'get_client__status':'servicestate/return_client_get__service_status_main',
    'get_aid__status':'servicestate/return_client_get__service_status_aid',

    'client_get__main_state':'servicestate/return_client_get__main_state',
    'update_main_program_online':'servicestate/return_update_main_program_online',
    'post_aid__running_main_program':'servicestate/return_running_main_program_online',
    'post_aid__shutdown_main_program':'servicestate/return_shutdown_main_program_online',
    'post_aid__update_main_program':'servicestate/return_update_main_program',
    'regcustomer__add':'regcustomer/return_regcustomer__add',
    'regcustomer__delete':'regcustomer/return_regcustomer__delete',
    'regcustomer__export':'regcustomer/return_regcustomer__export',
    'regcustomer__list':'regcustomer/return_regcustomer__list',
    'regcustomer__import':'regcustomer/return_regcustomer__import',

    'get_client__spr_data':'quotaionOms/return-spr-data',
    'get_client__oms_data':'quotaionOms/return-oms-data',
    'get_client__oms_generate':'quotaionOms/return-generate-data',
}

const _charStr = 'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789';
/**
 * 随机生成索引
 * @param min 最小值
 * @param max 最大值
 * @param i 当前获取位置
 */
function RandomIndex(min, max, i){
    let index = Math.floor(Math.random()*(max-min+1)+min),

        // numStart = _charStr.length - 10;
        numStart = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length - 10;
    //如果字符串第一位是数字，则递归重新获取
    if(i==0&&index>=numStart){
        index = RandomIndex(min, max, i);
    }
    //返回最终索引值
    return index;
}
/**
 * 随机生成字符串
 * @param len 指定生成字符串长度
 */
function getRandomString(len){
    // let min = 0, max = _charStr.length-1, _str = '';
    let min = 0, max = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length-1, _str = '';
    //判断是否指定长度，否则默认长度为15
    len = len || 15;
    //循环生成字符串
    for(var i = 0, index; i < len; i++){
        index = RandomIndex(min, max, i);
        // _str += _charStr[index];
        _str += "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789"[index];
    }
    return _str;
}

function fetchUserNameForWS() {
    let key = localStorage.getItem('user-key')
    if(!key){
        key = getRandomString(5)
        localStorage.setItem('user-key',key)
    }
    return fetchUserBase().username + (key ? ('%' + key) : '')
}

const actions = {
    //只需要在登录后初始化一次即可
    async ['socket_init']({ state, commit, dispatch }) {
        dispatch('netmanager/setup', null, {root: true})
        commit('update_channel_options')
        ws_init()
    },
    async ['socket_send']({ state, dispatch }, payload) {
        payload['for'] = fetchUserNameForWS()
        // console.log('req//',payload);
        //加入到管理堆栈
        if(!(isNotEmpty(payload?.['is_not_net_request']) && payload?.['is_not_net_request'])){
            dispatch('netmanager/net_request', {api: payload.command}, {root: true})
        }
        ws_send(JSON.stringify(payload))
    },
    async ['socket_close']({ state, dispatch }) {
        ws_close()
        dispatch('netmanager/stop', null, {root: true})
    },
    async ['socket_message']({ commit, dispatch }, payload) {
        let wsName = fetchUserNameForWS()
        if (payload.for === wsName) {
            if(payload.to=="client"){
                console.log(wsName+'--发送指令：', payload)
            }else{
                console.log('消息返回：', payload)
            }
        }
        if (payload.to == 'front' && payload['for'] == wsName) {
            dispatch(`${command_mapping[payload.command]}`, payload.message, { root: true })
            if (payload.message && !payload.message.success && (typeof payload.message) != 'string') {

                dispatch('response/set-response', { status: 400, socket_error: payload?.message?.errors ? payload.message.errors : payload.message.msg, command: payload.command }, { root: true })
                dispatch('netmanager/net_fail', {api: payload.command}, {root: true})
                return
            }
            dispatch('netmanager/net_sucess', {api: payload.command}, {root: true})
        }
    },
    async ['socket_msg_timeout']({ commit, dispatch }, payload) {
        dispatch(`${command_mapping[payload.command]}`, payload.message, { root: true })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
